import React from 'react';
import { Tooltip } from '@material-ui/core';

const UploadIcon = ({ id, value, tooltip = 'Cargar Archivo', title }) => {
	return (
		<Tooltip title={tooltip}>
			<div>
				<label
					htmlFor={id == undefined ? 'file-input' : id}
					className="btn btn-primary"
				>
					{title ? title : 'Examinar'}
				</label>
				<input hidden id={id == undefined ? 'file-input' : id} type="file" />
			</div>
		</Tooltip>
	);
};

export default UploadIcon;
